import { CALL_EVENTS } from "../socketEvents";
import {
  incomingCall,
  acceptCall,
  openRating,
  resetCallState,
} from "../../features/call/callSlice";
import { showError } from "../../utils/toast";
import CallAudioManager from "../../utils/CallAudioManager";

export const registerCallHandlers = (socket, dispatch, getState) => {
  socket.on(CALL_EVENTS.CALL_INCOMING, (data) => {
    console.log("CALL_INCOMING >>> ", data);
    CallAudioManager.playIncoming();
    dispatch(incomingCall(data));
  });

  socket.on(CALL_EVENTS.CALL_STARTED, (data) => {
    console.log("CALL_STARTED >>> ", data);

    CallAudioManager.stopAll();

    dispatch(acceptCall(data));
  });

  socket.on(CALL_EVENTS.CALL_ENDED, (data) => {
    console.log("CALL_ENDED >>> ", data);

    CallAudioManager.stopAll();

    const { callId } = getState().call;

    if (data?.endReason === 2 && callId)
    {
      CallAudioManager.playBusy();
      showError("User is busy");
    }
    else if (data?.endReason === 3)
      showError("User is not answering your call");

    const { role } = getState().auth.user;
    role === "user" && data?.duration > 0 ? dispatch(openRating({ callId: data?.callId })) : dispatch(resetCallState());
  });
};

export const unregisterCallHandlers = (socket) => {
  socket.off(CALL_EVENTS.CALL_INCOMING);
  socket.off(CALL_EVENTS.CALL_STARTED);
  socket.off(CALL_EVENTS.CALL_ENDED);
};